'use client';

import React, { FC } from 'react';
import { TypeGlobalNavFields } from '@/core/generated-types';
import LargeNav from './LargeNav';
import SmallNav from './SmallNav';

export const GlobalNav: FC<TypeGlobalNavFields> = (props) => {
  return (
    <>
      <LargeNav {...props} />
      <SmallNav {...props} />
    </>
  );
};

export default React.memo(GlobalNav);
